// Environment variable validation utility

export const validateEnvironment = () => {
  const requiredVars = [
    'REACT_APP_API_URL',
    'REACT_APP_ADMIN_X_API_KEY',
    'REACT_APP_X_API_KEY',
    'REACT_APP_API_LEVEL'
  ];

  const missingVars = requiredVars.filter(varName => !process.env[varName]);

  if (missingVars.length > 0) {
    console.error('Missing required environment variables:', missingVars);
    console.error('Please check your .env file and ensure all required variables are set.');
    return false;
  }

  console.log('✅ All required environment variables are set');
  return true;
};

export const getApiConfig = () => {
  return {
    apiUrl: process.env.REACT_APP_API_URL,
    adminApiKey: process.env.REACT_APP_ADMIN_X_API_KEY,
    appApiKey: process.env.REACT_APP_X_API_KEY,
    apiLevel: process.env.REACT_APP_API_LEVEL || '1',
    environment: process.env.REACT_APP_ENV || 'development'
  };
};

export const logApiHeaders = (config: any) => {
  console.log('🌐 API Request Headers:', {
    url: config.url,
    method: config.method,
    'ADMIN-X-API-KEY': config.headers['ADMIN-X-API-KEY'] ? '✅ Set' : '❌ Missing',
    'X-API-KEY': config.headers['X-API-KEY'] ? '✅ Set' : '❌ Missing',
    'api-level': config.headers['api-level'] ? '✅ Set' : '❌ Missing',
    'Authorization': config.headers.Authorization ? '✅ Set' : '❌ Missing',
    'X-Requested-With': config.headers['X-Requested-With'] ? '✅ Set' : '❌ Missing'
  });
};
